import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import SystemAlerts from "../components/alerts/SystemAlerts";
import Spinner from "../components/misc/Spinner";
import { useAuth } from "../context/AuthContext";
import { TaskProvider } from "../context/TaskContext";

const AuthenticatedApp = React.lazy(() => import("./AuthenticatedApp"));
const UnauthenticatedApp = React.lazy(() => import("./UnauthenticatedApp"));

const App: React.FC = () => {
  const { ready, loggedIn } = useAuth();

  if (!ready) {
    return <Spinner />;
  }

  return (
    <React.Suspense fallback={<Spinner />}>
      <Router>
        <TaskProvider>{loggedIn ? <AuthenticatedApp /> : <UnauthenticatedApp />}</TaskProvider>
      </Router>
      <SystemAlerts />
    </React.Suspense>
  );
};

export default App;
